import Lottie from "react-lottie";
import ListsAnim from "../assets/lottie/list.json";

function ListCardContent() {
  const defaultLottieOptions = {
    loop: true,
    autoplay: true,
    animationData: ListsAnim,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <div className="flex justify-end flex-col w-full h-full relative pb-8">
      <div>
        <Lottie options={defaultLottieOptions} width="100%" height="auto" />
      </div>
    </div>
  );
}

export default ListCardContent;
